import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, MinusCircleIcon, OctagonAlertIcon } from 'lucide-react';
import type { HealthStatus } from '../types/monitor';
import { statusLabels } from '../utils/health';
const tone: Record<HealthStatus, string> = {
  healthy: 'bg-healthy-soft text-healthy-ink border-healthy-border',
  warning: 'bg-warn-soft text-warn-ink border-warn-border',
  critical: 'bg-critical-soft text-critical-ink border-critical-border',
  paused: 'bg-paused-soft text-paused-ink border-paused-border'
};
const icons: Record<HealthStatus, typeof CheckCircle2Icon> = {
  healthy: CheckCircle2Icon,
  warning: AlertTriangleIcon,
  critical: OctagonAlertIcon,
  paused: MinusCircleIcon
};
interface StatusBadgeProps {
  status: HealthStatus;
  label?: string;
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  label,
  size = 'sm'
}: StatusBadgeProps) {
  const Icon = icons[status];
  return <span className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${tone[status]} ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'}`} data-id="element-429" data-mp="bzaogqhxwxrx">
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} aria-hidden="true" data-id="element-430" data-mp="25gm1c2qyx53p" />
      {label ?? statusLabels[status]}
    </span>;
}